import type {
  AnnotationSetDraft,
  AnnotationWorkspaceSnapshot,
  SavedAnnotationSet,
  TrackingConditioningKeyframe,
} from "./types";

export function resolvePersistedAnnotationSet(
  workspace: AnnotationWorkspaceSnapshot,
  draft: AnnotationSetDraft | null,
): SavedAnnotationSet | null {
  const setId = draft?.base?.setId;
  if (!setId) return null;
  return workspace.annotationSets.find((candidate) => candidate.setId === setId) ?? null;
}

export function createPersistedTrackingConditioningKeyframes(
  workspace: AnnotationWorkspaceSnapshot,
  draft: AnnotationSetDraft | null,
  streamId: string,
): readonly TrackingConditioningKeyframe[] {
  const savedSet = resolvePersistedAnnotationSet(workspace, draft);
  if (!savedSet) return [];

  return savedSet.orderedFrames.flatMap((frame) => {
    if (frame.streamId !== streamId) return [];
    const targets = Object.fromEntries(
      Object.entries(frame.targets).filter(([, target]) => target.points.length > 0),
    );
    if (Object.keys(targets).length === 0) return [];
    return [{ ...frame, targets }];
  });
}

export function persistedTrackingConditioningStreamIds(
  workspace: AnnotationWorkspaceSnapshot,
  annotationSetId: string | null | undefined,
): ReadonlySet<string> {
  const streamIds = new Set<string>();
  const annotationSet = annotationSetId
    ? workspace.annotationSets.find((candidate) => candidate.setId === annotationSetId)
    : undefined;
  for (const frame of annotationSet?.orderedFrames ?? []) {
    if (Object.values(frame.targets).some((target) => target.points.length > 0)) {
      streamIds.add(frame.streamId);
    }
  }
  return streamIds;
}
